(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enterprise-split-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.enterprise-mobile-split-hero';
    const mediaQuery = window.matchMedia('(max-width: 749px)');
    const sectionState = new WeakMap();

    const updateSection = (section) => {
      const state = sectionState.get(section);
      if (!state) return;

      if (mediaQuery.matches) {
        state.mediaGrid.before(state.heading);
      } else if (state.originalParent?.isConnected) {
        state.originalParent.insertBefore(state.heading, state.originalNextSibling);
      }
    };

    const initializeSection = (section) => {
      if (!section || sectionState.has(section)) return;

      const mediaGrid = section.querySelector('.hero__media-grid');
      const contentWrapper = section.querySelector('.hero__content-wrapper');
      const heading = contentWrapper?.querySelector('.enter_title');

      if (!mediaGrid || !contentWrapper || !heading) return;

      sectionState.set(section, {
        mediaGrid,
        heading,
        originalParent: heading.parentNode,
        originalNextSibling: heading.nextSibling
      });

      updateSection(section);
    };

    const initializeAllSections = (scope = document) => {
      if (scope.matches?.(selector)) initializeSection(scope);
      scope.querySelectorAll?.(selector).forEach(initializeSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAllSections());
    } else {
      initializeAllSections();
    }

    const updateAllSections = () => {
      document.querySelectorAll(selector).forEach((section) => {
        initializeSection(section);
        updateSection(section);
      });
    };

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', updateAllSections);
    } else {
      mediaQuery.addListener(updateAllSections);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAllSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
